import React from 'react';
import {
    Button, Col, Row, Breadcrumb, Input, Table, Modal, Spin, Form,
    Typography, Popconfirm, Radio, Divider, Upload
} from 'antd';
import Icon from '@ant-design/icons';
import {
    cardLayout,
    colLisTabelaConfigs,
    inputNome,
} from './GridStyle';
import ImgCrop from 'antd-img-crop';
import 'antd/dist/antd.css';
import { FaCogs } from 'react-icons/fa';
import useIconeModulo from './useIconeModulo';
import { urlIconeModuloImagem, urlMembroEntidadeFoto } from '../../../../../services/request/urls';

const IconCogs = (props: any) => <Icon {...props} component={FaCogs} ></Icon>

const { Title } = Typography;



const ListIconeModulo: React.FC = () => {

    const {
        onClickVoltarConfigOfSystem,
        hasSelectedAdd,
        clickBotaoAdicionar,
        clickBotaoEditar,
        hasSelectedEdit,
        selectedRowKeys,
        ativarOuInativarModulo,
        clickBotaoDeletarDados,
        loadingTable,
        onclickTable,
        rowSelection,
        columns,
        dadosTabelaState,
        modalAddConfigVisible,
        clickSubmitModalAddConfig,
        clickCancelModalAddConfig,
        loadingFormAdd,
        formRef,
        icon,
        setIcon,
        beforeUploadImage,
        image,
        onChangeNome
    } = useIconeModulo();

    return (
        <>
            <Row>
                <Col {...cardLayout}>
                    <Title level={3}><IconCogs style={{ fontSize: 35 }} /> Configurações do Sistema</Title>
                    <Breadcrumb>
                        <Breadcrumb.Item><a href='#' onClick={onClickVoltarConfigOfSystem}>Configurações do Sistema</a></Breadcrumb.Item>
                        <Breadcrumb.Item>Ícones de Módulos</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider />
                </Col>
            </Row>
            <Row style={{ marginBottom: 16 }}>
                <Col>
                    <Button type="primary" className="botaoAdicionarAssociacao" disabled={!hasSelectedAdd} onClick={clickBotaoAdicionar} >
                        Adicionar
                    </Button>

                </Col>
                <Col>
                    <Button type="primary" className="botaoEditarAssociacao" onClick={clickBotaoEditar} disabled={!hasSelectedEdit} >
                        Editar
                    </Button>
                    {selectedRowKeys.length === 1 ?
                            <>
                                <Popconfirm
                                    title="Deseja realmente excluir o ícone?"
                                    onConfirm={() => clickBotaoDeletarDados(false)}
                                    onCancel={() => { }}
                                    okText="Sim"
                                    cancelText="Não"
                                >
                                    <Button className="botaoDeleteAssociacao" type="primary" danger
                                        // disabled={!hasSelectedDel}
                                        disabled={!hasSelectedEdit}
                                    >
                                        Excluir
                                    </Button>
                                </Popconfirm>
                            </>
                        :
                        <></>
                    }
                </Col>
            </Row>
            <Row>
                <Col {...colLisTabelaConfigs}>
                    <Table
                        loading={loadingTable}
                        rowKey={(record) => record.uuid}
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: event => { onclickTable(record, rowIndex) }, // click row
                            };
                        }}
                        rowSelection={rowSelection}
                        columns={columns} dataSource={dadosTabelaState}
                        size="small"
                        pagination={{ locale: { items_per_page: '' } }}
                    />
                </Col>
            </Row>
            <Modal
                title="Adicionar Ícone"
                visible={modalAddConfigVisible}
                className="modalAddAssociacao"
                onOk={clickSubmitModalAddConfig}
                onCancel={clickCancelModalAddConfig}
                footer={[
                    <Button key="back" disabled={loadingFormAdd} onClick={clickCancelModalAddConfig}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loadingFormAdd} onClick={clickSubmitModalAddConfig}>
                        Salvar
                    </Button>,
                ]}
            >
                <Spin spinning={loadingFormAdd}>
                    <Form
                        ref={formRef}
                        name="formModalAddAssociacao"
                        layout="vertical"
                        initialValues={{
                            remember: true,
                        }}
                        onFinishFailed={() => { }}
                    >
                        <Row gutter={16}>
                            <Col hidden {...inputNome}>
                                <Form.Item
                                    name="id"
                                    label="id"
                                    rules={[
                                        {
                                            required: false,
                                            message: "Por favor preencha o id!",
                                        },
                                    ]}
                                >
                                    <Input placeholder="id" disabled />
                                </Form.Item>
                                <Form.Item name="image" label="Image">
                                    <Input placeholder="image" disabled />
                                </Form.Item>
                            </Col>
                            <Col span={18}>
                                <Form.Item
                                    rules={[
                                        {
                                            required: true,
                                            message: "Preencha o nome do ícone!",
                                        }
                                    ]}
                                    name="nome"
                                    label="Nome"
                                    style={{ margin: 5 }}
                                >
                                    <Input placeholder="Nome" onChange={onChangeNome} />
                                </Form.Item>
                                    <span style={{ color: 'red', fontSize: 12 }}>*O nome do ícone deve ser o mesmo que está no aplicativo.</span>

                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item
                                            name="descricao"
                                            label="Descrição"
                                            style={{ margin: 5 }}
                                        >
                                            <Input placeholder="Descrição" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={4}>
                                {/* Adicionar imagem do membro */}
                                <Form.Item name="imagemItem" label="Ícone"
                                >
                                    <ImgCrop
                                        fillColor='transparent'
                                        modalOk="Concluído"
                                        modalCancel="Cancelar"
                                        modalTitle="Editar"
                                        minZoom={0.5}
                                    >
                                        <Upload
                                            fileList={[]}
                                            listType="picture-card"
                                            // className="avatar-uploader"
                                            style={{
                                                width: "100%",
                                                height: 108,
                                                borderRadius: 10,
                                                marginTop: 15,
                                            }}
                                            showUploadList={false}
                                            // customRequest={()}

                                            beforeUpload={(file) => {
                                                // image = file;
                                                beforeUploadImage(file);
                                                return false;
                                            }}

                                        >
                                            <img
                                                src={
                                                    image !== null
                                                        ? image?.uid ? URL.createObjectURL(image) : urlIconeModuloImagem + image
                                                        : "/default-icon.png"
                                                }
                                                alt={image}
                                                style={{
                                                    width: 108,
                                                    height: 108,
                                                    marginTop: 0,
                                                    borderRadius: 10,
                                                }}
                                                className="membro-upload"

                                            />
                                        </Upload>
                                    </ImgCrop>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
}

export default ListIconeModulo;
